import React, { FC } from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { SettingsHeaderProps } from '@components/settings/v2/common/SettingsHeader';

interface HeaderMoreButtonProps extends Pick<SettingsHeaderProps, 'action' | 'actionActive'> {}

const HeaderMoreButton: FC<HeaderMoreButtonProps> = ({ action, actionActive }) => {
  return (
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginRight: scale(18) }}>
      <TouchableElement onPress={action}>
        {({ boxStyle }) => (
          <View style={[boxStyle]}>
            <Svg icon="more" width={scale(20)} height={scale(20)} color={actionActive ? 'Button/Light/Secondary' : 'Button/Light/Primary'} />
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default HeaderMoreButton;
